// @flow
export const filterId: 'period' = 'period';
